<template>
    <div>
        <v-card elevation="3" class="my-8 mb-6" style="padding:20px;" v-if="partner && parentSefa !== this.sefaTypeEnum.AttorneyAgent && parentSefa !== this.sefaTypeEnum.StudentWali && (partner.documentTypeName || partner.documentNumber || partner.documentIssueDateHijri)">
            <div class="row">
                <b class="">
                    بيانات الصك :
                </b>
            </div>
            <div class="row mb-5" v-if="partner && parentSefa !== this.sefaTypeEnum.AttorneyAgent">

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.documentTypeName">
                    <label for="disabledTextInput">نوع الصك </label>
                    <p class="mb-0">
                        <b>{{partner.documentTypeName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.documentNumber">
                    <label for="disabledTextInput">رقم الصك </label>
                    <p class="mb-0">
                        <b>{{partner.documentNumber}}</b>
                    </p>
                </div>
                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.documentIssueDateHijri">
                    <label for="disabledTextInput">تاريخ إصدار الصك </label>
                    <p class="mb-0">
                        <b>{{partner.documentIssueDateHijri}} هـ</b>
                    </p>
                </div>
                <div class="row"></div>
            </div>
        </v-card>
        <!-- #region بيانات الشخص -->
        <v-card elevation="3" class="my-8 mb-6" style="padding:20px;">
            <div class="mb-5 d-flex justify-content-between">
                <h4 class="py-3">
                    <b>
                        {{ partner.firstName }} {{ partner.fatherName }} {{ partner.grandFatherName }}
                        {{ partner.familyName }}
                    </b>

                </h4>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.socialId">
                    <label for="disabledTextInput">نوع الهوية</label>
                    <p>
                        <b> {{ partner.socialId | getSocialIdType }}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.socialId">
                    <label for="disabledTextInput">رقم الهوية</label>
                    <p class="mb-0"> <b> {{ partner.socialId }} </b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label for="disabledTextInput">الصفة</label>
                    <p class="mb-0">
                        <b v-if="parentSefa === this.sefaTypeEnum.Wali">المولى عليه ({{ partner.partnerSefaTypeName }})</b>
                        <b v-else-if="parentSefa === this.sefaTypeEnum.Wasi">الموصى عليه ({{ partner.partnerSefaTypeName }})</b>
                        <b v-else-if="parentSefa === this.sefaTypeEnum.AttorneyAgent">موكل ({{ partner.partnerSefaTypeName }})</b>
                        <b v-else>{{ partner.partnerSefaTypeName }}</b>
                    </p>

                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.authorizerSefaName">
                    <label for="disabledTextInput">صفة الممثل النظامي</label>
                    <p class="mb-0"> <b>{{ partner.authorizerSefaName }}</b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.accordingName">
                    <label for="disabledTextInput">بموجب</label>
                    <p class="mb-0">
                        <b>{{partner.accordingName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.authorizationNumber && (partner.accordingId === 3 || partner.accordingId === 4 || partner.accordingId === 5)">
                    <label for="disabledTextInput"> رقم {{partner.accordingName}} </label>
                    <p class="mb-0">
                        <b>{{partner.authorizationNumber}}</b>
                    </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label for="disabledTextInput">الجنسية</label>
                    <p class="mb-0"> <b>{{ partner.nationalityName }}</b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow">
                    <label for="disabledTextInput">النوع</label>
                    <p class="mb-0">
                        <b v-if="partner.gender === '1'"> ذكر </b>
                        <b v-if="partner.gender === '2'"> أنثى </b>
                    </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="partner.birthDate">
                    <label for="disabledTextInput">تاريخ الميلاد</label>
                    <p class="mb-0">
                        <b>
                            {{ partner.birthDate | formatGregToHijri }} هـ -
                            {{ partner.birthDate | getFormattedDate }}م
                        </b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.maritalStatusName">
                    <label for="disabledTextInput">الحالة الاجتماعية </label>
                    <p class="mb-0">
                        <b>{{partner.maritalStatusName}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="partner.passport">
                    <label for="disabledTextInput">رقم الجواز </label>
                    <p class="mb-0">
                        <b>{{partner.passport}}</b>
                    </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="showIban && partner.partnerSefaTypeId != sefaTypeEnum.Authorizer && partner.iban">
                    <label for="disabledTextInput">الآيبان </label>
                    <p class="mb-0">
                        <b>{{partner.iban}}</b>
                    </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="showContacts && partner.mobileNumber">
                    <label for="disabledTextInput">رقم التواصل</label>
                    <p class="mb-0"> <b>{{ partner.mobileNumber }}</b></p>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-12 cutom-box-shadow" v-if="showContacts && partner.email">
                    <label for="disabledTextInput">البريد الإلكتروني</label>
                    <p class="mb-0"> <b>{{ partner.email }}</b></p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="showContacts">
                    <label for="disabledTextInput">رقم الهاتف </label>
                    <p class="mb-0">

                    <p class="mb-0" v-if="showContacts && partner.telephone"> <b>{{partner.telephone}}</b></p>
                    <p class="mb-0" v-else>  لايوجد </p>
                </div>

                <div class="col-lg-3 col-md-12 col-sm-12 cutom-box-shadow" v-if="showContacts">
                    <label for="disabledTextInput">العنوان الوطني المختصر  </label>
                    <p class="mb-0"></p>
                    <p class="mb-0" v-if="partner.abbreviatedNationalAddress">  <b>{{partner.abbreviatedNationalAddress}}</b></p>
                    <p class="mb-0" v-else>لايوجد</p>

                </div>

                <div class="row"></div>
                <div class="col-lg-12 col-md-12 col-sm-12 cutom-box-shadow" v-if="showContacts && partner.nationalAddress">
                    <label for="disabledTextInput">العنوان الوطني</label>
                    <p class="mb-0">
                        <!--<b>المدينة: {{ partner.nationalAddress.city }} - الحي: {{ partner.nationalAddress.district }} - الشارع : {{ partner.nationalAddress.street }} - رقم المبني: {{ partner.nationalAddress.buildingNumber }} - الرقم الفرعي: {{ partner.nationalAddress.subNumber }} - الرقم البريدي : {{ partner.nationalAddress.postalCode }}</b>-->
                        <b>المدينة: <b v-if="partner.nationalAddress.city"> {{ partner.nationalAddress.city }} </b> <b v-else> - </b> ، </b>
                        <b>الحي: <b v-if="partner.nationalAddress.district"> {{ partner.nationalAddress.district }} </b> <b v-else> - </b> ، </b>
                        <b>الشارع: <b v-if="partner.nationalAddress.street"> {{ partner.nationalAddress.street }} </b> <b v-else> - </b> ، </b>
                        <b>رقم المبني: <b v-if="partner.nationalAddress.buildingNumber"> {{ partner.nationalAddress.buildingNumber }} </b> <b v-else> - </b> ، </b>
                        <b>الرقم الفرعي: <b v-if="partner.nationalAddress.subNumber"> {{ partner.nationalAddress.subNumber }} </b> <b v-else> - </b> ، </b>
                        <b>الرمز البريدي: <b v-if="partner.nationalAddress.postalCode"> {{ partner.nationalAddress.postalCode }} </b> <b v-else> - </b></b>
                    </p>
                </div>

            </div>
            <br />
        </v-card>

        <!-- #endregion -->

    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';
    import { SefaTypeEnum } from '@/enums/SefaTypeEnum';
    import { ContractPartnerModel } from '@/models/contractPartnerModel';

    @Component
    export default class ContractPersonComponent extends Vue {
        @Prop({ required: true }) partner!: ContractPartnerModel;
        @Prop({ required: true }) showContacts!: boolean;
        @Prop({ required: true }) showIban!: boolean;
        @Prop({ required: false }) parentSefa!: number | null;
        sefaTypeEnum = SefaTypeEnum;

    }
</script>